module.exports = __webpack_public_path__ + "img/aquassist.a606e222.png";